export const messageTextClasses =
  "text-sm font-normal whitespace-pre-line text-darkest";
